import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';

const getTextColor = (props) =>
  props.textColor
    ? props.theme.colors[props.textColor]
      ? props.theme.colors[props.textColor]
      : props.textColor
    : 'white';

const ButtonContainer = styled.div`
  height: ${(props) => (props.height ? props.height : '45px')};
  width: ${(props) => (props.width ? props.width : '140px')};
  background-color: ${(props) =>
    props.color
      ? props.theme.colors[props.color]
        ? props.theme.colors[props.color]
        : props.color
      : props.theme.colors['terra-cotta']};
  color: ${(props) => getTextColor(props)};
  border: ${(props) => (props.border ? props.border : 0)};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : '4px'};
  display: flex;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '400')};
  letter-spacing: ${(props) =>
    props.letterSpacing ? props.letterSpacing : '1px'};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  padding: ${(props) => (props.padding ? props.padding : '0')};
  align-items: center;
  text-align: center;
  font-family: ${(props) =>
    props.fontFamily
      ? props.fontFamily
      : props.theme.fonts.sfcompact_text} !important;
  text-transform: ${(props) =>
    props.textTransform ? props.textTransform : 'uppercase'};

  flex-flow: ${(props) => (props.iconLeft ? 'row-reverse' : 'row')};

  justify-content: center;
  &:hover {
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  }

  div {
    width: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: ${(props) => (props.iconLeft ? '0px' : '9px')};
    margin-right: ${(props) => (props.iconLeft ? '9px' : '0px')};
    height: 18px;
    border-radius: 50%;
    background-color: ${(props) =>
      props.iconContainerColor
        ? props.iconContainerColor
        : props.color
          ? props.color
          : props.theme.colors['terra-cotta']};
  }

  .iconButtonContainer {
    font-size: ${(props) => (props.sizeIcon ? props.sizeIcon : '14px')};
    background-color: transparent;
  }

  a {
    color: ${(props) => getTextColor(props)};
    text-decoration: none;
    display: flex;
    flex-direction: row-reverse;
  }

  span {
    width: ${(props) => (props.widthText ? props.widthText : undefined)};
  }
`;

const ButtonRound = styled.div`
  width: ${(props) => (props.size ? props.size : '32px')};
  height: ${(props) => (props.size ? props.size : '32px')};
  border-radius: 50%;
  display: flex;
  &:hover {
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  }
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.iconColor ? props.iconColor : 'white')};
  background-color: ${(props) =>
    props.color ? props.color : props.theme.colors['terra-cotta']};

  .div {
    color: ${(props) => (props.iconColor ? props.iconColor : 'white')};
  }
`;

const buttonContent = (label, icon) => (
  <React.Fragment>
    <span>{label}</span>
    {icon && (
      <div className="iconButtonContainer">
        <Icon icon={icon} />
      </div>
    )}
  </React.Fragment>
);

const getButtonContent = (type, url, downloadLink, label, icon) => {
  if (type && type === 'link') {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        download={downloadLink}
      >
        {buttonContent(label, icon)}
      </a>
    );
  }
  return buttonContent(label, icon);
};

const Button = ({
  // eslint-disable-next-line react/prop-types
  onClick,
  // eslint-disable-next-line react/prop-types
  label,
  // eslint-disable-next-line react/prop-types
  icon,
  // eslint-disable-next-line react/prop-types
  type = 'default',
  // eslint-disable-next-line react/prop-types
  url = null,
  // eslint-disable-next-line react/prop-types
  disabled = false,
  // eslint-disable-next-line react/prop-types
  downloadLink = false,
  // eslint-disable-next-line react/prop-types
  ...otherProps
}) =>
  type && type === 'round' ? (
    <ButtonRound
      onClick={!disabled && onClick}
      disabled={disabled}
      {...otherProps}
    >
      <Icon icon={icon} />
    </ButtonRound>
  ) : (
    <ButtonContainer
      onClick={!disabled && !(type && type === 'link') ? onClick : undefined}
      disabled={disabled}
      {...otherProps}
    >
      {getButtonContent(type, url, downloadLink, label, icon)}
    </ButtonContainer>
  );

export default Button;
